import PaymentsIcon from '@mui/icons-material/Payments';

import CostList from './CostList';
import CostCreate from './CostCreate';
import CostShow from './CostShow';
import CostEdit from './CostEdit';

const costs = {
	list: CostList,
	create: CostCreate,
	show: CostShow,
	edit: CostEdit,
	icon: PaymentsIcon
};

export default costs;
